function initListButtonsAlt() {

	const containers = document.querySelectorAll(".list-buttons-alt");


	containers.forEach((container) => {
		const select = container.querySelector(".list-buttons-alt__select");
		const dropdown = container.querySelector(".list-buttons-alt__dropdown");
		const placeholder = container.querySelector(".list-buttons-alt__placeholder");
		const buttons = container.querySelectorAll(".list-buttons-alt__button");

		if (!select || !dropdown) return;

		// Toggle dropdown
		select.addEventListener("click", () => {
			const isOpen = dropdown.classList.toggle("is-open");
			select.setAttribute("aria-expanded", isOpen);
		});

		// Sélection d'un bouton : ferme le dropdown + met à jour le placeholder
		buttons.forEach((btn) => {
			btn.addEventListener("click", () => {
				buttons.forEach((b) => b.classList.remove("is-active"));
				btn.classList.add("is-active");

				if (placeholder) {
					placeholder.textContent = btn.textContent.trim();
				}

				dropdown.classList.remove("is-open");
				select.setAttribute("aria-expanded", "false");
			});
		});

		// Fermer au clic en dehors
		document.addEventListener("click", (e) => {
			if (!container.contains(e.target)) {
				dropdown.classList.remove("is-open");
				select.setAttribute("aria-expanded", "false");
			}
		});
	});
}

export { initListButtonsAlt };


